<template>
  <div class="bq-product-sjzlgl">
    <SectionTitle :title="'产品简介'" noSpacing></SectionTitle>
    <div class="container-div">
      <div class="container">
        <div class="left-mark"></div>
        <p>
          数据质量管理平台，用于解决业务系统运行、数据中心建设过程中各种数据质量问题。
        </p>
        <p>
          它以全面的数据管理方法为指导，充分结合医疗数据质量管理特点，通过数据质量分析，全面提升数据的完整性、规范性、及时性、一致性等，降低数据管理成本，提高数据利用率。
        </p>
        <div class="right-mark"></div>
      </div>
      <div class="area">
        <div class="area-title">
          业务监控平台
        </div>
        <div class="area-content">
          <div class="content-item">
            <div class="content-item-content">
              <div class="content-item-title">
                组织建设
              </div>
              <div class="content-item-desc">
                <div class="item-title">机构管理</div>
                <div class="item-title">系统管理</div>
              </div>
            </div>
            <div class="content-item-content">
              <div class="content-item-title">
                质量监控
              </div>
              <div class="content-item-desc">
                <div class="item-title">检验结果报警</div>
                <div class="item-title">检测结果报警</div>
              </div>
            </div>
            <div class="content-item-content">
              <div class="content-item-title">
                质量标准管理
              </div>
              <div class="content-item-desc">
                <div class="item-title">质控规则</div>
                <div class="item-title">质控规则配置</div>
              </div>
            </div>
          </div>
          <div class="content-item">
            <div class="content-item-content">
              <div class="content-item-title">
                质量报告
              </div>
              <div class="content-item-desc">
                <div class="item-title">数据质量日报</div>
                <div class="item-title">质量监控报告</div>
                <div class="item-title">质量绩效报告</div>
              </div>
            </div>
            <div class="content-item-content">
              <div class="content-item-title">
                元数据管理
              </div>
              <div class="content-item-desc">
                <div class="item-title">数据集管理</div>
                <div class="item-title">元数据管理</div>
                <div class="item-title">数据源管理</div>
              </div>
            </div>
            <div class="content-item-content">
              <div class="content-item-title">
                质控任务管理
              </div>
              <div class="content-item-desc">
                <div class="item-title">实时任务管理</div>
                <div class="item-title">离线任务管理</div>
                <div class="item-title">任务日志</div>
              </div>
            </div>
          </div>
          <div class="arrow-content">
            <div class="arrow"></div>
            <div class="arrow-desc">数据层</div>
            <div class="arrow"></div>
          </div>
          <div class="btm-bg"></div>
        </div>
      </div>
    </div>
    <SectionTitle :title="'产品优势'" noSpacing></SectionTitle>
    <div class="bq-advantage">
      <div class="advantage-content">
        <div class="advantage-title">质量评估</div>
        <div class="advantage-desc">
          提供全方位数据质量评估能力，如数据的重复性、关联性、正确性、完全性、一致性、合规性等，对数据进行全面体检。
        </div>
        <div class="advantage-title">数据丰富</div>
        <div class="advantage-desc">
          提供内容丰富的数据质量分析报告。
        </div>
      </div>
      <div class="advantage-content1">
        <div class="advantage-title">直观反馈</div>
        <div class="advantage-desc2">
          快速直观的分析反馈数据质量问题所在。
        </div>
        <div class="advantage-title">灵活配置</div>
        <div class="advantage-desc">
          灵活配置数据质量控制规则
        </div>
      </div>
      <div class="advantage-content2">
        <div class="advantage-title">针对提升</div>
        <div class="advantage-desc">
          建立长效反馈机制，针对性提升数据质量。
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/website_v3/SectionTitle';

export default {
  name: 'zsjgl',
  data() {
    return {
      proIntros: [
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1.Ve4DxD1gK0jSZFsXXbldVXa-72-90.png',
          advTitles: '管理',
          advDesc: '主要管理医疗基础数据及建立规范的数据应用标准',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1N3eVDuL2gK0jSZPhXXahvXXa-86-92.png',
          advTitles: '建立',
          advDesc: '建立一套健康信息化标准体系',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1BHu4DxD1gK0jSZFsXXbldVXa-80-84.png',
          advTitles: '改善',
          advDesc: '从根本上改善和解决医疗系统之间的数据标准问题',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB12RC9DAT2gK0jSZFkXXcIQFXa-86-90.png',
          advTitles: '促进',
          advDesc:
            '确保整个区域或医疗机构数据使用同一套数据标准，促进数据的互认互通',
        },
      ],
      advantageList: [
        [
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1RIKVDND1gK0jSZFsXXbldVXa-92-72.png',
            advTitles: '一站式监控解决方案',
            advDesc:
              '插件自动化插件部署，一站式插件化管理、应用性能监控、系统性能监控。',
          },
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB17d5UDFY7gK0jSZKzXXaikpXa-88-88.png',
            advTitles: '网络质量拔测监控',
            advDesc:
              '网络质量监控统计，分析、报表和图表展示，实时反应网络质量情况。',
          },
        ],
        [
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB1mOuWDHr1gK0jSZFDXXb9yVXa-72-88.png',
            advTitles: '基于事件、自定义指标、日志监控',
            advDesc:
              '自定义基于事件过滤规则、监控指标、日志事件监控，实时处理监控数据。',
          },
          {
            iconUrl:
              'https://img.alicdn.com/tfs/TB19tC3DHj1gK0jSZFuXXcrHpXa-84-84.png',
            advTitles: '数据报表',
            advDesc:
              '监控数据分为图形报表、文档报表，统计分析结果表达等多形式展示数据信息。',
          },
        ],
      ],
    };
  },
  components: {
    SectionTitle,
  },
};
</script>
<style lang="less" scoped>
@import './sjzlgl.less';
</style>
